// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import './common/js/rem'
import './common/less/index.less'
import 'lib-flexible/flexible'
import Vue from 'vue'
import App from './App'
import router from './router'
import {
  initWxSDK
} from '@/utils/wxSDK'
// import vConsole from '@/utils/vconsole.js'
import {
  DatetimePicker,
  Cell,
  CellGroup,
  NoticeBar,
  Area,
  Dialog,
  AddressEdit,
  Switch,
  Form,
  Field,
  Button,
  Checkbox,
  CheckboxGroup,
  Toast,
  Uploader,
  Icon,
  Picker,
  Popup,
  Image as VanImage,
  Loading,
  Overlay,
  Search
} from 'vant'
Vue.use(Form)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(DatetimePicker)
Vue.use(Field)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Checkbox);
Vue.use(NoticeBar);
Vue.use(CheckboxGroup);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(AddressEdit);
Vue.use(VanImage);
Vue.use(Toast);
Vue.use(Search);
Vue.use(Loading);
Vue.use(Area);
Vue.use(Overlay);
Vue.use(Switch);
Vue.config.productionTip = false
initWxSDK()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js